import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { queryKeys as sharedQueryKeys } from '../../queryKeys';
import { clearAuth } from '../../store/jwtMiddleware/clearAuth';
import { creators as tokenCreators } from '../../store/jwtMiddleware/tokenDuck';
import errorCodes from '../../util/errorCodes';
import { login, loginWithActiveDirectory } from './loginApi';

const validateCredentials = credentials => {
  if (!(credentials?.token && credentials.refreshToken && credentials.expires)) {
    throw new Error(errorCodes.HTTP_RESPONSE_STATUS_UNAUTHORIZED);
  }
  return credentials;
};

const useAuthenticationMutation = mutationFn => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn,
    onSuccess: credentials => {
      queryClient.removeQueries({ queryKey: [sharedQueryKeys.USER] });
      dispatch(tokenCreators.setToken(credentials.token, credentials.refreshToken, credentials.expires));
    },
  });
};

export const useLoginMutation = () =>
  useAuthenticationMutation(({ username, password }) => login(username, password).then(validateCredentials));

export const useActiveDirectoryLoginMutation = () =>
  useAuthenticationMutation(adToken => loginWithActiveDirectory(adToken).then(validateCredentials));

export const useLogout = () => {
  const dispatch = useDispatch();

  return useCallback(() => {
    clearAuth(dispatch);
  }, [dispatch]);
};
